import { useState, useMemo } from 'react'
import { CreditCard, Shield, Users, KeyRound } from 'lucide-react'
import AccountTab from './AccountTab'
import OwnerAccountsTab from './OwnerAccountsTab'
import AssignedSocialAccountsTab from './AssignedSocialAccountsTab'
import AssignedCredentialsTab from './AssignedCredentialsTab'
import SectionBlock from '../UI/SectionBlock'
import SectionHeader from '../UI/SectionHeader'

const TABS = [
  { id: 'assigned',    suffix: 'assigned_accounts' },
  { id: 'owner',       suffix: 'owner_accounts' },
  { id: 'social',      suffix: 'assigned_social_accounts' },
  { id: 'credentials', suffix: 'assigned_credentials' },
]

const AccountsSection = ({ talent, hasPermission }) => {
  const canRead = (suffix) => hasPermission('talent-service', `${talent.talent_type}_${suffix}`, 'read')

  const defaultTab = useMemo(
    () => TABS.find(t => canRead(t.suffix))?.id ?? 'assigned',
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [talent.talent_type]
  )

  const [accountSubTab, setAccountSubTab] = useState(defaultTab)
  const tabCls = (id) => `px-3 py-1.5 text-xs font-medium rounded-full border transition-colors ${
    accountSubTab === id
      ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-400 border-primary-200 dark:border-primary-800'
      : 'text-light-text-secondary dark:text-dark-text-secondary border-light-border-secondary dark:border-dark-border-secondary hover:bg-light-bg-secondary dark:hover:bg-dark-bg-secondary'
  }`

  return (
    <SectionBlock id="accounts">
      <SectionHeader icon={CreditCard} title="Accounts" />
      <div className="flex gap-2 mb-4 flex-wrap">
        {canRead('assigned_accounts') && (
          <button onClick={() => setAccountSubTab('assigned')} className={tabCls('assigned')}>
            <CreditCard className="h-3.5 w-3.5 inline mr-1" />Assigned Accounts
          </button>
        )}
        {canRead('owner_accounts') && (
          <button onClick={() => setAccountSubTab('owner')} className={tabCls('owner')}>
            <Shield className="h-3.5 w-3.5 inline mr-1" />Owner Accounts
          </button>
        )}
        {canRead('assigned_social_accounts') && (
          <button onClick={() => setAccountSubTab('social')} className={tabCls('social')}>
            <Users className="h-3.5 w-3.5 inline mr-1" />Social Accounts
          </button>
        )}
        {canRead('assigned_credentials') && (
          <button onClick={() => setAccountSubTab('credentials')} className={tabCls('credentials')}>
            <KeyRound className="h-3.5 w-3.5 inline mr-1" />Credentials
          </button>
        )}
      </div>
      {accountSubTab === 'assigned' && canRead('assigned_accounts') && (
        <AccountTab userId={talent.auth_user_id} talentType={talent.talent_type} />
      )}
      {accountSubTab === 'owner' && canRead('owner_accounts') && (
        <OwnerAccountsTab ownerId={talent.auth_user_id} talentType={talent.talent_type} />
      )}
      {accountSubTab === 'social' && canRead('assigned_social_accounts') && (
        <AssignedSocialAccountsTab userId={talent.auth_user_id} talentType={talent.talent_type} />
      )}
      {accountSubTab === 'credentials' && canRead('assigned_credentials') && (
        <AssignedCredentialsTab userId={talent.auth_user_id} talentType={talent.talent_type} isSelf={false} />
      )}
    </SectionBlock>
  )
}

export default AccountsSection
